import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { publicApi } from '../lib/api';
import { Loader2 } from 'lucide-react';
import SapPageRenderer from '../components/SapPageRenderer';
import PageSeo from '../components/PageSeo';

export default function SapPage() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notAvailable, setNotAvailable] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await publicApi.getSAPPage();
        setContent(response.data);
      } catch (error) {
        setNotAvailable(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#A5BBA8]" />
      </div>
    );
  }

  if (notAvailable || !content) {
    return (
      <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center">
        <div className="text-center">
          <p className="text-[#5C6A61] mb-4">Cette page n'est pas disponible.</p>
          <Link to="/" className="btn-primary">Retour à l'accueil</Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageSeo title="Crédit d'impôt 50 % et Avance immédiate | Mitonner" description="Préparation de repas à domicile éligible au crédit d'impôt de 50 % et à l'Avance immédiate (services à la personne)." />
      <SapPageRenderer content={content} />
    </>
  );
}
